import { all, put, takeEvery, call } from 'redux-saga/effects';

import { CreateIMCActionTypes, CreateForgotPasswordActionTypes, getPaymentsDetailsActionTypes } from '../actionsTypes';
// import { createEmployees } from '../mockController';
import { createIMCController, forgotPasswordController, getPaymentsController } from '../controller';

function* handleCreateIMCRequest(action, props) {
    try {
        const { params, axiosConfig } = action.payload;
        yield put({ type: CreateIMCActionTypes.INPROGRESS });

        const createimc = yield call(createIMCController, params, axiosConfig);

        yield put({ type: CreateIMCActionTypes.SUCCESS, payload: createimc });
    } catch (e) {
        // console.warn('FAILED to handle get Employees request due to', e.message);
        yield put({ type: CreateIMCActionTypes.FAILED, error: e.message });
    }
}

function* handleRequestForgotPassword(action) {
    try {
        const { params } = action.payload;
        yield put({ type: CreateForgotPasswordActionTypes.INPROGRESS });
        const forgotPassword = yield call(forgotPasswordController, params);
        yield put({ type: CreateForgotPasswordActionTypes.SUCCESS, payload: forgotPassword });
    } catch (e) {
        // console.warn('FAILED to handle get Employees request due to', e.message);
        yield put({ type: CreateForgotPasswordActionTypes.FAILED, error: e.message });
    }
}

function* handleRequestGetPayments() {
    try {
        yield put({ type: getPaymentsDetailsActionTypes.INPROGRESS });
        const payments = yield call(getPaymentsController);
        yield put({ type: getPaymentsDetailsActionTypes.SUCCESS, payload: payments });
    } catch (e) {
        // console.warn('FAILED to handle get Employees request due to', e.message);
        yield put({ type: getPaymentsDetailsActionTypes.FAILED, error: e.message });
    }
}


function* watchCreateIMCRequest() {
    yield takeEvery(CreateIMCActionTypes.REQUEST, handleCreateIMCRequest);
    yield takeEvery(CreateForgotPasswordActionTypes.REQUEST, handleRequestForgotPassword);
    yield takeEvery(getPaymentsDetailsActionTypes.REQUEST, handleRequestGetPayments);
}

export function* createIMCSaga() {
    yield all([
        watchCreateIMCRequest()
    ]);
}
